module.exports = __webpack_public_path__ + "img/Industrial.32373a8f.svg";